// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"5e5bbad4","591":"43ee23c4","646":"624691cd"}[chunkId] + ".chunk.js";
};